module.exports = __webpack_public_path__ + "img/footer-line.4f52a3dc.png";